import styled, { Scale, Typography } from '@secretescapes/falcon';
import { type CommonStyledProps } from '@utils/styles.utils';

export const Container = styled('div')<CommonStyledProps>`
  display: flex;
  flex-direction: column;
  ${({ isMobile }) => isMobile && `gap: ${Scale.xs}`};
  background-color: transparent;
  ${({ theme }) => `font-family: ${theme.fontFamilyBody.join(',')}`};
`;

export const Subtitle = styled(Typography)`
  cursor: pointer;
  text-decoration: underline;
`;
